import { Box, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { Translate as T } from "react-localize-redux";
var useStyles = makeStyles(function (theme) { return ({
    headerContent: {
        background: "rgba(38, 54, 107, 0.1)",
        borderRadius: theme.spacing(1, 1, 0, 0),
        minHeight: theme.spacing(8),
    },
    logo: {
        maxHeight: theme.spacing(5),
        height: "auto",
        width: "100%",
    },
    title: {
        alignItems: "center",
        color: theme.typography.subtitle1.color,
        fontSize: "16px",
    },
}); });
export var SimpleHeader = function () {
    var _a = useCheckoutContext().checkoutSection.header, title = _a.title, Logo = _a.logo;
    var classes = useStyles();
    return (React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", className: classes.headerContent }, Logo ? (React.createElement(Logo, { className: classes.logo })) : (React.createElement(Typography, { variant: "subtitle1" },
        React.createElement(T, { id: title })))));
};
export default SimpleHeader;
